import React from 'react';
import { getHistory, getChangeMessage, ResultRecord } from '../utils/resultHistory';

interface ResultHistoryProps {
  currentRecord: ResultRecord;
  quizId?: string;
  unit?: string;
}

const ResultHistory: React.FC<ResultHistoryProps> = ({ currentRecord, quizId, unit = '살' }) => {
  const history = getHistory(quizId);
  const changeMessage = getChangeMessage(currentRecord, quizId, unit);

  if (history.length < 2) return null;

  return (
    <div style={{ width: '100%', maxWidth: '500px', margin: '20px 0' }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' }}>
        📈 이전 결과와 비교
      </p>

      {changeMessage && (
        <div style={{
          backgroundColor: '#f3e5f5',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '12px',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#6a1b9a',
        }}>
          {changeMessage}
        </div>
      )}

      <div style={{
        backgroundColor: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        overflow: 'hidden',
      }}>
        {history.slice(1, 6).map((record, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 16px',
              borderBottom: index < Math.min(history.length - 2, 4) ? '1px solid #f0f0f0' : 'none',
            }}
          >
            <div style={{ fontSize: '13px', color: '#888' }}>{record.date}</div>
            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>
              {record.lifeExpectancy}{unit}
            </div>
            <div style={{ fontSize: '12px', color: '#6a1b9a' }}>{record.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultHistory;
